import React from 'react';
import { PracticeFormula } from './PracticeFormula';
import { FenceLine } from './FenceLine';
const coverage = [{
  label: 'One card per group, per day',
  body: 'Setup, timed blocks, distances, reps, rest and cues. Athletes read it, do it and initial it.'
}, {
  label: '60 · 75 · 90 minutes',
  body: 'The same five blocks, with the minutes already worked out for your slot.'
}, {
  label: 'The Level Dial: Y · MS · HS',
  body: 'One line on every card adjusts the volume for Youth (8–12), Middle School and High School.'
}, {
  label: 'Coach-supervised where it matters',
  body: 'Throws, hurdles, high jump and pit jumps never run on their own, all season. Every card says so.'
}, {
  label: 'The 4-Phase Season Map',
  body: 'Foundation, Build, Compete, Peak. Every event group has practices for every phase.'
}, {
  label: 'Bad-weather versions',
  body: 'Hallway, gym and indoor practices in every volume. Rain doesn’t cancel practice.'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="lane-band w-full bg-navy" data-id="element-332" data-mp="1b0626e3w3hvo">
      <div className="mx-auto max-w-6xl px-5 py-16 text-center sm:py-20" data-id="element-333" data-mp="1f1hkrzocj2ud">
        <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-hl" data-id="element-334" data-mp="1jsr6wqaoro1i">The system</p>
        <h2 id="mechanism-heading" className="mt-3 font-display text-3xl text-chalk sm:text-5xl" data-id="element-335" data-mp="1osvo6ijf4mss">
          The Fence Card System
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-chalk/80 sm:text-lg" data-id="element-336" data-mp="s3o3fcqmihpx">
          More drills don&apos;t fix it. You already have saved videos, old
          workouts and notes on your phone. What&apos;s missing is the practice:
          what each group does today, for how long, with how much rest. Every
          Track Coach Ready practice is a printable card for each event group,
          posted on the fence at its station. Low-risk groups work from their
          card while you stand where the risk is. Print it, post it on the
          fence, run practice.
        </p>

        <div className="mx-auto mt-10 grid max-w-5xl gap-4 lg:grid-cols-[1.15fr_.85fr]" data-id="element-337" data-mp="1rrkuomdqwdul">
          <PracticeFormula data-id="element-338" data-mp="1mszps9njt5zt" />
          <FenceLine data-id="element-339" data-mp="1mvvo3z3b5wos" />
        </div>

        <ul className="mx-auto mt-6 grid max-w-5xl gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-340" data-mp="21qs6v68qu2g4">
          {coverage.map(item => <li key={item.label} className="rounded-lg border border-navy-line bg-chalk/5 px-4 py-3" data-id="element-341" data-mp="1wta11oq0w3cc">
              <span className="block text-[11px] font-semibold uppercase tracking-widest text-hl" data-id="element-342" data-mp="192w8lx3j02h8">{item.label}</span>
              <span className="mt-1 block text-sm text-chalk/85" data-id="element-343" data-mp="1416wsf8hbks3">{item.body}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}